export enum AvailableComponents {
  CustomerProfile = 0,
  WishedSolution,
  PeoplephoneSIPTRUNK,
  PeoplephoneHosted,
  Datasim,
  mobile,
  PeoplefoneBundle,
  ThreeCX,
  MicrosoftTeams,
  OperatorConnect,
  SBCplus,
  PeoplefoneMittel,
  NewPhoneNumbers,
  PhoneNumbersToBePorted,
  FlatRateSIPTRUNK,
  FlatRateHOSTED,
  PeoplephoneInternetIPworldcom,
  PeoplephoneInternetCyberlink ,
  PeoplephoneDevicesDataBase ,
  MyDevicesDataBase,
  FollowUp,
  OfferSummary,
  Management,
  ManageMyDevices,
  EditManagement,
  EditMyDevices,
  MyOffers

}



// WEBPACK FOOTER //
// ./src/app/side-bar/enumAvailableComponents.ts